
import { useEffect } from 'react';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import BlogHero from './components/BlogHero';
import BlogContent from './components/BlogContent';

export default function BlogLifecycle() {
  useEffect(() => {
    // Set page title
    document.title =
      'From Site Planning to Stripping: The Lifecycle of Professional Formwork Design | Dinari Designs';

    // Update meta description safely
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        'content',
        "Good design doesn't just help with setup; it helps with the strike. Walk through the complete formwork workflow from initial consultation to construction sequencing drawings for Vancouver projects."
      );
    }

    // Update meta keywords safely
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute(
        'content',
        'construction sequencing, formwork lifecycle, AutoCAD site planning Vancouver, formwork design process, professional construction workflow'
      );
    }

    // Create JSON‑LD script tag with proper error handling
    try {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.dataset.schema = 'blog-lifecycle';
      script.textContent = JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'Article',
        headline:
          'From Site Planning to Stripping: The Lifecycle of a Professional Formwork Design',
        description:
          "Good design doesn't just help with setup; it helps with the strike. Walk through the complete workflow from initial consultation to construction sequencing drawings.",
        author: {
          '@type': 'Organization',
          name: 'Dinari Designs',
        },
        publisher: {
          '@type': 'Organization',
          name: 'Dinari Designs',
          logo: {
            '@type': 'ImageObject',
            url: 'https://static.readdy.ai/image/f0c3f25d25166b296c2998ed1e07db56/4ed16d38f79ad8245b8fcfc88558374a.jfif',
          },
        },
        datePublished: '2024-03-15',
        dateModified: new Date().toISOString().split('T')[0],
      });

      // Avoid duplicate insertion
      if (!document.head.querySelector('script[data-schema="blog-lifecycle"]')) {
        document.head.appendChild(script);
      }
    } catch (err) {
      // Gracefully log any unexpected errors during script creation
      console.error('Failed to inject JSON‑LD schema:', err);
    }

    // Cleanup on unmount
    return () => {
      const schemaScript = document.head.querySelector(
        'script[data-schema="blog-lifecycle"]'
      );
      if (schemaScript) {
        schemaScript.remove();
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <BlogHero />
      <BlogContent />
      <Footer />
    </div>
  );
}
